import { v4 as uuidv4 } from 'uuid';
import { create } from 'zustand';

import type { DialogRootProps, DialogContentProps } from './types';

export interface DialogStoreProps
  extends Omit<DialogRootProps, 'open' | 'onOpenChange'>,
    Omit<DialogContentProps, 'global'> {
  content: (closeModal: () => void) => JSX.Element;

  /**
   * On close action
   */
  onClose?: () => void;
}

interface QueueItem extends DialogStoreProps {
  id: string;
}

export interface DialogStoreState {
  queue: QueueItem[];
  showModal: (props: DialogStoreProps) => void;
  closeModal: (id: string) => void;
}

export const useDialogStore = create<DialogStoreState>((set, get) => ({
  queue: [],

  showModal: (props) => {
    // Prevent duplicate dialogs (dialogs with the same title are considered duplicates)
    if (get().queue.some((elem) => elem.title === props.title)) {
      return;
    }
    const elem = { ...props, id: uuidv4() };

    set((state) => {
      return {
        queue: state.queue.concat(elem),
      };
    });
  },

  closeModal: (id) => {
    if (id) {
      set((state) => ({
        queue: state.queue.filter((elem) => {
          if (elem.id === id) {
            elem.onClose?.();
          }
          return elem.id !== id;
        }),
      }));
    }
  },
}));

export const dialogStoreSelector = {
  currentDialog: (state: DialogStoreState) => state.queue[0],
  showModal: (state: DialogStoreState) => state.showModal,
  closeModal: (state: DialogStoreState) => state.closeModal,
};
